import { Flex, Text } from '@chakra-ui/react'
import { User } from '../../../components/Header/HeaderCustomer/User'
import { useUser } from '../../../hooks/useUser'
import { Outlet } from 'react-router-dom'

export const LayoutOmnipromo = () => {
  const { nome_usuario: nomeUsuario, avatar_url: avatarUrl } = useUser()

  return (
    <>
      {/* <Flex alignItems="center" justifyContent={'space-between'} bg="#313E44" p={4} color="white" position="sticky" top={0} zIndex={1000}> */}
      {/* <Flex alignItems="center" gap={2}>
          <Text fontSize="2xl" color="#37F091">
            {'</>'}
          </Text>
          <Text fontSize="2xl" fontWeight="bold">
            OmniPromo
          </Text>
        </Flex> */}

      {/* <User userName={nomeUsuario} avatarUrl={avatarUrl} /> */}
      {/* </Flex> */}

      <Outlet />
    </>
  )
}
